<template>
  <div>
    <v-col cols="12">
      <h3 class="font-weight-bold">
        {{ dataField.title ? dataField.title : "" }}
      </h3>
    </v-col>
    <v-btn-toggle
      v-model="defaultValue"
      class="toggle-box"
      :style="{'display':dataField.choices.length>4?'grid':'inline'}"
      mandatory
      color="deep-teal accent-3"
      tile
    >
      <v-btn  small text disabled >
      انتخاب نمایید
      </v-btn>
      <v-btn
        v-for="(item, index) in dataField.choices"
        :key="index"
        large
        @click="setValue(item.key)"
      >
        {{ item.value }}
      </v-btn>
    </v-btn-toggle>
     <v-alert type="error" v-if="alerts[dataField.name] != null">{{alerts[dataField.name]}}</v-alert>
  </div>
</template>

<script>
export default {
  name: "ToggleBox",
  props: ["dataField"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  watch: {
    dataField: function () {
      this.defaultValue = 0;
    },

  },
  data: () => ({
    required: [(v) => !!v || "اجباری می باشد"],
    defaultValue: 0,
  }),
  mounted() {
    //TODO set defaultValue by choises and value
  },
  methods: {
    setValue(val) {
      this.$store.commit("updateDataPostByIndex", {
        index: this.dataField.name,
        val: val,
      });
    },
  },
};
</script>
<style>
@media only screen and (max-width: 600px) {
  .toggle-box {
    display: grid !important;
  }
}

</style>